import React from 'react'
import ReactDOM from 'react-dom'
// Redux
// https://github.com/rt2zz/redux-persist
import {PersistGate} from 'redux-persist/integration/react'
import {Provider} from 'react-redux'
import * as _redux from './setup'
import store, {persistor} from './setup/redux/Store'
// Axios
import frFR from 'rsuite/locales/fr_FR'

import {Chart, registerables} from 'chart.js'

// Apps
import {App} from './app/App'
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'

// React-Query
import {CustomProvider} from 'rsuite'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
import 'rsuite/dist/rsuite.min.css'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import './index.css'


/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/* const mock = */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.SetupAxios(_redux.Axios, store)

Chart.register(...registerables)

const queryClient = new QueryClient()

const frLocale = {
    ...frFR,
    DateRangePicker: {
        ...frFR.DateRangePicker,
        ok: 'Appliquer',
    },
};

ReactDOM.render(
    <MetronicI18nProvider>
        <Provider store={store}>
            <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
                <QueryClientProvider client={queryClient}>
                    <CustomProvider locale={frLocale}>
                        <App basename={PUBLIC_URL} />
                    </CustomProvider>
                    <ReactQueryDevtools initialIsOpen={false} position={'bottom-right'} />
                </QueryClientProvider>
            </PersistGate>
        </Provider>
    </MetronicI18nProvider>,
    document.getElementById('root'),
)


